import { render, staticRenderFns } from "./BaseAvatarImage.vue?vue&type=template&id=60e882ae&scoped=true&"
import script from "./BaseAvatarImage.vue?vue&type=script&lang=js&"
export * from "./BaseAvatarImage.vue?vue&type=script&lang=js&"
import style0 from "./BaseAvatarImage.vue?vue&type=style&index=0&id=60e882ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../order-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e882ae",
  null
  
)

export default component.exports